/* Classy Search V4.2.3 — strictly read-only, fail-closed Shopify theme integration.
   The public storefront's own search is retained until the complete live index
   has been fetched and validated. Never substitute an outdated CSV for stock. */
(function(){
 'use strict';
 var E=window.ClassySearchV3,UI=window.ClassySearchV3UI,config=window.CLASSY_V3_CONFIG;
 if(!E||!UI||!config)return;
 var root=document.getElementById('classy-v3-results'),native=document.getElementById('classy-v3-native');
 var current=null,loading=null,view=null;
 var cacheKey='classy-v4-live-'+String(config.indexUrl||'').slice(-95);
 function clearBootTimer(){if(window.CLASSY_V3_BOOT_TIMEOUT){clearTimeout(window.CLASSY_V3_BOOT_TIMEOUT);window.CLASSY_V3_BOOT_TIMEOUT=null;}}
 function showNativeFallback(){
   clearBootTimer();
   if(document.body)document.body.classList.add('classy-v3-fallback');
   if(native)native.hidden=false;
   if(root){root.style.display='none';root.setAttribute('aria-busy','false');}
 }

 function getJSON(url){return fetch(url,{credentials:'same-origin',cache:'no-store'}).then(function(r){
   if(!r.ok)throw Error('HTTP '+r.status+' al solicitar catálogo');
   var ct=r.headers.get('content-type')||'';
   if(ct&&!/json|text\/html|text\/plain/i.test(ct))throw Error('Tipo de respuesta imprevisto');
   return r.json();
 });}
 function fetchPage(n){
   var prefix=String(config.root||'/').replace(/\/?$/,'/');
   return getJSON(prefix+'collections/all?view=classy-v3-feed&page='+n).then(function(d){
     if(!d||!Array.isArray(d.products)||!Number.isInteger(d.page)||!Number.isInteger(d.pages)||d.page!==n||d.pages<1||d.pages>120)
       throw Error('Paginación del catálogo inválida');
     return d;
   });
 }
 function readCache(){try{
   var c=JSON.parse(sessionStorage.getItem(cacheKey)||'null');
   if(c&&Date.now()-c.time<300000&&c.data&&Array.isArray(c.data.products)&&c.data.products.length)return c.data;
 }catch(_e){}return null;}
 function writeCache(data){try{sessionStorage.setItem(cacheKey,JSON.stringify({time:Date.now(),data:data}));}catch(_e){}}
 function fetchAll(){
   var c=readCache();if(c)return Promise.resolve(c);
   return fetchPage(1).then(function(first){
     var pages=[first],numbers=[];for(var n=2;n<=first.pages;n++)numbers.push(n);
     function batch(i){if(i>=numbers.length)return Promise.resolve();
       return Promise.all(numbers.slice(i,i+4).map(fetchPage)).then(function(next){pages.push.apply(pages,next);return batch(i+4);});
     }
     return batch(0).then(function(){
       if(pages.length!==first.pages||pages.some(function(p){return p.pages!==first.pages;}))throw Error('Feed incompleto');
       pages.sort(function(a,b){return a.page-b.page;});
       var products=[],seen=Object.create(null);
       pages.forEach(function(page){page.products.forEach(function(p){
         if(!p||typeof p.handle!=='string'||!p.handle||!p.title||!p.vendor)throw Error('Ficha incompleta');
         // La regla comercial exige published_at REAL. Un producto sin fecha
         // válida no puede ordenarse de manera verificable: activar fallback.
         var published=Number(p.published_at);
         if(!p.published_at||!Number.isFinite(published)||published<=0)throw Error('Fecha de publicación ausente o inválida');
         if(seen[p.handle])throw Error('Productos duplicados o paginación inconsistente');
         seen[p.handle]=true;products.push(p);
       });});
       if(products.length===0||products.length>6000)throw Error('Tamaño del catálogo anómalo');
       var result={products:products};writeCache(result);return result;
     });
   });
 }
 function start(){
   if(!loading)loading=getJSON(config.indexUrl).then(function(snapshot){
     if(!snapshot||!Array.isArray(snapshot.products))throw Error('Índice base inválido');
     return fetchAll().then(function(feed){
       // Every displayed listing is in the fresh public storefront feed.
       // Snapshot contains classification hints only for unchanged titles/vendors.
       var live=E.fromShopifyFeed(feed.products,snapshot),engine=E.create(live);
       if(!engine.products.length)throw Error('No se obtuvo ningún producto');
       current=engine;
       if(root&&native&&!document.body.classList.contains('classy-v3-fallback')){
         var q=new URLSearchParams(window.location.search).get('q')||'';
         view=UI.mount(root,current,{query:q,history:true});
         root.setAttribute('aria-busy','false');
         native.hidden=true;root.style.display='block';
         document.body.classList.add('classy-v3-ready');
         clearBootTimer();
       }
       UI.attachSuggestions({search:function(q,opts){return current.search(q,opts);}},document,{searchUrl:config.searchUrl});
       return engine;
     });
   }).catch(function(err){
     // Restore native search: never show a stale index as if it were live.
     showNativeFallback();
     if(window.console)console.warn('[Classy Search V4.2] Usando búsqueda nativa; índice no verificado:',err.message);
     loading=null;throw err;
   });
   return loading;
 }
 if(root)start().catch(function(){});
 document.addEventListener('focusin',function(event){
   if(!current&&event.target&&event.target.matches&&event.target.matches('form[action*="/search"] input[name="q"]'))
     start().catch(function(){});
 },true);
})();
